import {
  Box,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import './schedule-meeting-page.scss';
import { useMemo, useState } from 'react';
import { useTitle } from '../../hooks/useTitle.ts';

const selectStyles = {
  '& .MuiSelect-outlined': {
    padding: '8px',
    paddingLeft: '24px',
    'paddingRight:': '24px',
    textAlign: 'center',
    fontSize: '14px',
    minWidth: '200px',
  },
  '& .MuiOutlinedInput-notchedOutline': {},
};

const options = [
  {
    value: 'initial-general-informational-meeting',
    label: 'Initial Informational Meeting',
  },
  {
    value: 'discovery-checklist',
    label: 'Discovery Checklist',
  },
  {
    value: 'land-planning',
    label: 'Land planning',
  },
  {
    value: 'home-selection-design',
    label: 'Home selection / design',
  },
  {
    value: 'mortgage-construction-finance',
    label: 'Mortgage / construction / finance',
  },
];

export const ScheduleMeetingView = () => {
  useTitle('Schedule Meeting - Immersive Homes');

  const baseUrl = import.meta.env.VITE_HUBSPOT_BASE_URL as string;

  const src = import.meta.env.VITE_HUBSPOT_ENV as string;

  const stage =
    (import.meta.env.VITE_STAGE as string) === 'dev'
      ? 'sandbox'
      : (import.meta.env.VITE_STAGE as string);

  const [selectedTopic, setSelectedTopic] = useState<string>(options[0].value);

  const srcString = useMemo(() => {
    const suffix = stage === 'prod' ? '' : `-${stage}`;
    return `${baseUrl}/${src}/${selectedTopic}${suffix}?embed=true`;
  }, [baseUrl, selectedTopic, src, stage]);

  return (
    <Box className="schedule-meeting-page">
      <div>
        <Typography variant="h3">Schedule a Meeting</Typography>

        <Box
          sx={{
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <>
            <FormControl>
              <FormLabel sx={{ textAlign: 'center' }}>Meeting Topic</FormLabel>
              <Select
                inputProps={{ 'data-testid': 'meeting-topic-select' }}
                sx={{
                  ...selectStyles,
                }}
                value={selectedTopic}
                onChange={(e) => setSelectedTopic(e.target.value)}
              >
                {options.map((option, i) => (
                  <MenuItem key={i} value={option.value}>
                    {`${option.label}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        </Box>
      </div>
      <iframe
        data-testid={'hubspot-iframe'}
        title={'hubspot'}
        style={{
          width: '100%',
          flexGrow: 1,
          height: 1,
        }}
        src={srcString}
      />
    </Box>
  );
};
